import * as $ from 'jquery';
import { LarchSys } from '../../utils/larchSys';


export function navbarBlock(larchSys: LarchSys) {

    $('.navbar').each(function () {
        var $navbar = $(this);

        $navbar.find('.navbar-btn').on('click', () => {
            $navbar.toggleClass('open').toggleClass('mix-blend');
        });


        function render() {
            if (window.scrollY > 1) { $navbar.addClass('fixed').parent().addClass('fixed'); }
            else { $navbar.removeClass('fixed').parent().removeClass('fixed'); }
        }
        $(document).on('scroll', render);
        render();
    });

}